module.exports = __webpack_public_path__ + "img/Ellipse 31.e98e538e.svg";